import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    mobileNo: '',
    startDate: '',
    endDate: '',
    "travellers": [
        {
            "dob": "",
            "age": null,
            "relation":''
        }
    ],
    numberofDays: 0,
    tripType:'Single',
    destination: [],
    "enquiryNo": "",
    "policyType": "",
    "tripType": "",
    "tripDuration": "",
    "sumAssured": 0,
    "lotNo": "",
    "insurerID": "",
    sponsorDetails: {
        enabled: false,
        sponsorName: "",
        addressLine1: "",
        addressLine2: "",
        mobileNo: "",
        pincode: "",
        pincodeCity: null,
    },
    studentDetails: {
        universityName: "",
        courseDuration: "",
        numberOfSemester: "",
    },
  

};


const TravellerDetailsSlice = createSlice({
    name: "travellerDetails",
    initialState,
    reducers: {
        updateTravellerDetails: (state, action) => {
            Object.assign(state, action.payload);
        },
        resetTravellerDetails: () => initialState
    }

});

export const { updateTravellerDetails, resetTravellerDetails } = TravellerDetailsSlice.actions;
export default TravellerDetailsSlice.reducer;
